module.exports = __webpack_public_path__ + "media/images/puerta_automatica-75d3cb55.webp";